export default __webpack_public_path__ + "static/media/ero_light.1736b552.svg";